import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { useQuery } from "@apollo/client"
import _ from "lodash"

import ROUTES from "../../../components/Routes/routesContants"

// Context
import { UserContext } from "../../../context/userContext"

// Prime
import { TabView, TabPanel } from "primereact/tabview"

// Comps
import ParticipantProfileBoxSmall from "../../../components/ParticipantProfileBoxSmall"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"

import { LoaderMedium } from "../../../components/Loaders"
import Form from "./Form"

// Queries
import { GET_PARTICIPANT_PROFILE } from "./queries"
import styles from "../../../styles/Participant-Profile.module.css"

import GLOBALS_STATUS from "../../../config/globalsStatus"

export default function ParticipantProfile() {
  const userCtx = useContext(UserContext)

  const participant_id = userCtx.current_participant_id || null

  const [blocks, setBlocks] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)

  const navigate = useNavigate()

  const { loading, refetch } = useQuery(GET_PARTICIPANT_PROFILE, {
    variables: {
      participant_id,
      organization_id: userCtx.session.user?.organization_id,
    },
    fetchPolicy: "network-only",
    skip: _.isEmpty(participant_id),
    onCompleted: ({ participantProfile }) => {
      const sortBlocks = _.sortBy(participantProfile.blocks, ["index"])
      const renameBlocks = _.map(sortBlocks, (block) => {
        return {
          ...block,
          block_title: `${block.block_title}`.replace("Participant ", ""),
        }
      })

      setBlocks(renameBlocks)
    },
  })

  const handleBackBtn = () => {
    userCtx.clearParticipant(null)
    return navigate(ROUTES.PARTICIPANT_MYPARTICIPANTS)
  }

  const getWarningMessage = () => {
    const status = userCtx.participant_membership_status

    if (status === GLOBALS_STATUS.KIOSK_MEMBER) {
      return (
        <p>
          Participants in a kiosk member service episode have limited access and
          functions. You may start a new full service episode for further access
          or contact your Organization Administrator.
        </p>
      )
    }

    if (GLOBALS_STATUS.INACTIVE_STATUS.includes(status)) {
      return (
        <p>
          Discharged participants may not have their data edited. A new Service
          Episode may be started to facilitate further updates or contact your
          Organization Administrator.
        </p>
      )
    }

    return null
  }

  if (loading) return <LoaderMedium />

  if (_.isEmpty(participant_id)) {
    return (
      <div>
        <div className="layout-with-sidebar">
          <div className="sidebar">
            <ParticipantSidebar />
          </div>
          <div className="main-content">
            <h1>No Participant selected</h1>
            <div className={styles.breadcrumbs}>
              <button onClick={() => handleBackBtn()} className="btn-sm">
                Back to My Participants
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const warningMessage = getWarningMessage()

  return (
    <div>
      <div className="layout-with-sidebar">
        <div className="sidebar">
          <ParticipantSidebar />
        </div>

        <div className="main-content">
          <ParticipantProfileBoxSmall />

          <div className={styles.tabs}>
            {warningMessage && (
              <div
                className="mb-5 p-tag p-tag-warning"
                style={{ backgroundColor: "var(--yellow-200)" }}
              >
                {warningMessage}
              </div>
            )}

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {_.map(blocks, (block) => {
                return (
                  <TabPanel
                    key={block.block_name}
                    header={block.block_title}
                    id={block.block_name}
                  >
                    <Form
                      key={block.block_name}
                      participantId={participant_id}
                      blockName={block.block_name}
                      totalFields={block.total_fields}
                      triggerParticipantQuery={refetch}
                    />
                  </TabPanel>
                )
              })}
            </TabView>
          </div>
        </div>
      </div>
    </div>
  )
}
